export const validateNonZeroFloat = (field: string, value: string): string => {
  if (isNaN(Number(value))) {
    return `${field} must be a number`;
  }
  return "";
};

export const validateNonZeroInteger = (field: string, value: string): string => {
  if (isNaN(Number(value))) {
    return `${field} must be a number`;
  }
  if (!/^-?\d+$/.test(value)) {
    return `${field} must be an integer`;
  }
  return "";
};